import { IconLanguageSmall, IconPlay } from '../icons.js';

/**
 * Botón icon-only de reproducción (replay del TTS de la burbuja).
 *
 * `loading`/`errored` son OPCIONALES pero importan en la burbuja del usuario:
 * ahí el audio es la grabación real y NO hay fallback posible (la voz propia no
 * se puede re-sintetizar, a diferencia del coach, que cae a TTS). Sin estos dos
 * estados un fetch fallado se pintaba EXACTAMENTE igual que el reposo, así que
 * el botón se leía como "no hace nada" y la causa quedaba invisible.
 */
export function EscucharBtn({
  playing,
  onToggle,
  tone = 'lime',
  loading = false,
  errored = false,
  errorHint,
}: {
  playing: boolean;
  onToggle: () => void;
  /** Color del botón: lime (coach, default) o purple (burbuja del usuario). */
  tone?: 'lime' | 'purple';
  /** Buscando el audio (fetch en vuelo). */
  loading?: boolean;
  /** El último intento falló: se pinta en rojo en vez de simular reposo. */
  errored?: boolean;
  /** Motivo del fallo, para el tooltip/aria (no hay lugar para más texto). */
  errorHint?: string;
}) {
  const label = playing
    ? 'Detener'
    : loading
      ? 'Cargando audio'
      : errored
        ? `No se pudo reproducir el audio${errorHint ? `: ${errorHint}` : ''}`
        : 'Escuchar';
  return (
    <button
      type="button"
      className={`bubble-icon-btn listen-icon ${tone === 'purple' ? 'listen-icon-purple' : ''} ${playing ? 'is-playing is-stoppable' : ''} ${loading ? 'is-loading' : ''} ${errored ? 'is-errored' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-label={label}
      title={label}
    >
      {playing ? (
        <svg viewBox="0 0 12 12" width="10" height="10" fill="currentColor">
          <rect x="2" y="2" width="8" height="8" rx="1.8" />
        </svg>
      ) : loading ? (
        <span className="listen-spinner" aria-hidden="true" />
      ) : errored ? (
        <svg viewBox="0 0 12 12" width="11" height="11" fill="currentColor" aria-hidden="true">
          <path d="M6 1.6a.9.9 0 0 1 .9.9v3.6a.9.9 0 0 1-1.8 0V2.5a.9.9 0 0 1 .9-.9Zm0 6.6a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" />
        </svg>
      ) : (
        <IconPlay size={11} />
      )}
    </button>
  );
}

/** Botón icon-only para traducir una burbuja puntual (cuando el global está off). */
export function TranslateBubbleBtn({ active, onClick }: { active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      className={`bubble-icon-btn translate-icon ${active ? 'is-active' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={active ? 'Ocultar traducción' : 'Traducir burbuja'}
      title={active ? 'Ocultar traducción' : 'Traducir burbuja'}
    >
      <IconLanguageSmall size={13} />
    </button>
  );
}
